
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"9","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.067 0l-2.954 8.973H8.661L6.973 3.772l-1.77 5.201H2.759L0 0h2.513L4.12 5.799 6.078 0h1.911l1.822 5.799L11.558 0z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    